import { ADDBOOKS, DELETEBOOK, EDITBOOK, LOADBOOKS } from "./actionTypes";

export const loaded = (books) => {
  return {
    type: LOADBOOKS,
    payload: books,
  };
};

export const added = (name, author, thumbnail, price, rating, featured) => {
  return {
    type: ADDBOOKS,
    payload: { name, author, thumbnail, price, rating, featured },
  };
};

export const edited = (
  id,
  name,
  author,
  thumbnail,
  price,
  rating,
  featured
) => {
  return {
    type: EDITBOOK,
    payload: {
      id,
      name,
      author,
      thumbnail,
      price,
      rating,
      featured,
    },
  };
};
export const deleted = (id) => {
  return {
    type: DELETEBOOK,
    payload: id,
  };
};
